namespace AgerLMS.LMS {
    export interface QuizRow {
        QuizId?: number;
        CourseId?: number;
        SectionId?: number;
        QuizTitle?: string;
        Time?: number;
        NumberOfAttemps?: number;
        PassMark?: number;
        CertificateIncluded?: boolean;
        QuizType?: QuizTypes;
        StartDate?: string;
        ResultShowDate?: string;
        QuestionCount?: number;
        CourseCourseName?: string;
        SectionSectionName?: string;
        UserGrade?: number;
        CorrectAnswerCount?: number;
        QuizStatus?: QuizStatus;
        QuizStartDate?: string;
        QuizEndDate?: string;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
        IsActive?: number;
        InsertUserDisplayName?: string;
    }

    export namespace QuizRow {
        export const idProperty = 'QuizId';
        export const isActiveProperty = 'IsActive';
        export const nameProperty = 'QuizTitle';
        export const localTextPrefix = 'LMS.Quiz';
        export const lookupKey = 'LMS.Quiz';

        export function getLookup(): Q.Lookup<QuizRow> {
            return Q.getLookup<QuizRow>('LMS.Quiz');
        }
        export const deletePermission = 'LMS:Quiz:Modify';
        export const insertPermission = 'LMS:Quiz:Modify';
        export const readPermission = 'LMS:Quiz:Read';
        export const updatePermission = 'LMS:Quiz:Modify';

        export declare const enum Fields {
            QuizId = "QuizId",
            CourseId = "CourseId",
            SectionId = "SectionId",
            QuizTitle = "QuizTitle",
            Time = "Time",
            NumberOfAttemps = "NumberOfAttemps",
            PassMark = "PassMark",
            CertificateIncluded = "CertificateIncluded",
            QuizType = "QuizType",
            StartDate = "StartDate",
            ResultShowDate = "ResultShowDate",
            QuestionCount = "QuestionCount",
            CourseCourseName = "CourseCourseName",
            SectionSectionName = "SectionSectionName",
            UserGrade = "UserGrade",
            CorrectAnswerCount = "CorrectAnswerCount",
            QuizStatus = "QuizStatus",
            QuizStartDate = "QuizStartDate",
            QuizEndDate = "QuizEndDate",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate",
            IsActive = "IsActive",
            InsertUserDisplayName = "InsertUserDisplayName"
        }
    }
}
